// @flow
import React from 'react';
import type { Node } from 'react';

import styles from './PageContent.module.scss';

type Props = {
  containerClassName: string,
  contentClassName: string,
  children: Node
};

const PageContent = ({
  containerClassName,
  contentClassName,
  children
}: Props): Node => (
  <div className={`${styles.wrap} ${containerClassName}`}>
    <div className={`${styles.content} ${contentClassName}`}>{children}</div>
  </div>
);

PageContent.displayName = 'PageContent';

PageContent.defaultProps = {
  containerClassName: '',
  contentClassName: ''
};

export default PageContent;
